/** Viewport: maps reference-image pixel coordinates to screen (CSS px) coordinates. */
export class Viewport {
  scale = 1;
  tx = 0;
  ty = 0;
  dpr = window.devicePixelRatio || 1;

  constructor(public canvas: HTMLCanvasElement) {}

  resize(): void {
    this.dpr = window.devicePixelRatio || 1;
    const r = this.canvas.getBoundingClientRect();
    this.canvas.width = Math.round(r.width * this.dpr);
    this.canvas.height = Math.round(r.height * this.dpr);
  }

  toScreen(x: number, y: number): [number, number] {
    return [x * this.scale + this.tx, y * this.scale + this.ty];
  }

  toImage(sx: number, sy: number): [number, number] {
    return [(sx - this.tx) / this.scale, (sy - this.ty) / this.scale];
  }

  zoomAt(sx: number, sy: number, factor: number): void {
    const next = Math.min(64, Math.max(0.02, this.scale * factor));
    factor = next / this.scale;
    this.tx = sx - (sx - this.tx) * factor;
    this.ty = sy - (sy - this.ty) * factor;
    this.scale = next;
  }

  panBy(dx: number, dy: number): void {
    this.tx += dx;
    this.ty += dy;
  }

  fit(w: number, h: number): void {
    const r = this.canvas.getBoundingClientRect();
    this.scale = Math.min(r.width / w, r.height / h) * 0.98;
    this.tx = (r.width - w * this.scale) / 2;
    this.ty = (r.height - h * this.scale) / 2;
  }

  /** Fill the canvas (may crop the image) — nicer initial view on phones. */
  fitCover(w: number, h: number): void {
    const r = this.canvas.getBoundingClientRect();
    this.scale = Math.max(r.width / w, r.height / h);
    this.tx = (r.width - w * this.scale) / 2;
    this.ty = (r.height - h * this.scale) / 2;
  }
}
